const tabChange = (): void => {
  const tabMenus: NodeListOf<HTMLAnchorElement> = document.querySelectorAll('.js-tab-menu');
  const tabItems: NodeListOf<HTMLElement> = document.querySelectorAll('.js-tab-item');

  // data-tab=0以外の要素を非表示
  tabItems.forEach((item: HTMLElement, index: number) => {
    if (index !== 0) {
      item.style.display = 'none';
    }
  });

  tabMenus.forEach((menu: HTMLAnchorElement, index: number) => {
    menu.addEventListener('click', (e: Event) => {
      e.preventDefault();
      menu.closest('li')?.classList.add('is-active');
      tabMenus.forEach((item: HTMLAnchorElement) => {
        if (item !== menu) {
          item.closest('li')?.classList.remove('is-active');
        }
      });

      const id: string = menu.getAttribute('data-tab') || '';
      const target: HTMLElement | null = document.querySelector(`[data-tab-item="${id}"]`);
      tabItems.forEach((item: HTMLElement) => {
        if (item === target) {
          item.style.display = 'block';
        } else {
          item.style.display = 'none';
        }
      });
    });
  });
};

export default tabChange;
